import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import * as fromTask from './reducer'
import { EffectsModule } from '@ngrx/effects'
import { TaskAccessEffects } from './effects'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('task-access', fromTask.taskAccessesReducer),
    EffectsModule.forFeature([TaskAccessEffects]),
  ],
  declarations: [],
})
export class TaskAccessStoreModule {}
